import * as React from 'react';

import { AutocompleteProps } from '@lightspeed/flame/Autocomplete';

import Autocomplete from '..';
import GuiDefHiddenInput from '../GuiDefHiddenInput';

const ShopsAutocomplete: React.FC<AutocompleteProps> = ({
  isClearable = true,
  value: parentValue,
  defaultValue,
  defaultOptions = [],
  placeholder = 'Shop(s)',
  hiddenInput,
  options: parentOptions,
  onChange: parentOnChange = () => {},
  ...rest
}) => {
  const [value, setValue] = React.useState(defaultValue);
  const [options] = React.useState(parentOptions || defaultOptions);

  const { value: hiddenInputValue = '' } = value || {};

  React.useEffect(() => {
    setValue(parentValue);
  }, [parentValue]);

  return (
    <>
      <Autocomplete
        aria-label="shops-autocomplete-input"
        {...rest}
        value={value}
        options={options}
        placeholder={!rest.isDisabled && placeholder}
        isClearable={isClearable}
        onChange={(newValue: { label: string; value: string }) => {
          setValue(newValue);
          parentOnChange(newValue);
        }}
      />

      {hiddenInput ? <GuiDefHiddenInput {...hiddenInput} defaultValue={hiddenInputValue} /> : null}
    </>
  );
};

export default ShopsAutocomplete;
